
const Definition = {

    plan_level: 1,
    id: "launchpad",
    name: "Launchpad",
    path: "host/launchpad/components/Landing",
    preview_image: "https://img.freepik.com/free-vector/gradient-rocket-background_23-2148146034.jpg?semt=ais_hybrid&w=740&q=80",
    colors: {
        background: "#0A0A0F",
        background_alt: "#111118",
        surface: "#1A1A24",
        surface_alt: "#22222E",
        text: "#E8E8F0",
        text_muted: "#7A7A96",
        primary: "#C9A84C",
        primary_light: "#E8C96A",
        accent: "#4F6EF7",
        success: "#22C55E",
        danger: "#EF4444",
        warning: "#F97316"
    },
    legacy_color_keys: {
        background: "dark",
        background_alt: "dark2",
        surface: "dark3",
        surface_alt: "dark4",
        text_muted: "muted",
        primary: "gold",
        primary_light: "gold_light",
        success: "green",
        danger: "red",
        warning: "orange"
    }

};

export default Definition;
